import { Link, useForm } from '@inertiajs/react';
import React, { ReactNode } from 'react';
import { Button, Card, Form, Alert } from 'react-bootstrap';
import GuestLayout from '../../Layouts/Guest';

interface Props {
	status?: string;
}

const ForgotPassword = (props: Props) => {
	const { data, setData, post, processing, errors, reset } = useForm({
		email: '',
	});

	const submit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		post('/forgot-password');
	};

	return (
		<Card className='login-card p-9 rounded-4'>
			<Card.Body>
				{props.status && <Alert className='mb-3'>{props.status}</Alert>}
				<p className='mb-4'>
					Enter your email and we'll send you a password reset link.
				</p>
				<Form onSubmit={submit}>
					<Form.Group controlId='email' className='mb-3'>
						<Form.Label>Email</Form.Label>
						<Form.Control
							type='email'
							value={data.email}
							onChange={(e) => setData('email', e.target.value)}
						/>
						<div className='mt-2 text-dkRed'>{errors.email}</div>
					</Form.Group>
					<Button
						variant='secondary'
						type='submit'
						disabled={processing}
						className='mt-3 w-100'
					>
						{props.status ? 'Resend Reset Link' : 'Send Password Reset Link'}
					</Button>
				</Form>
				<div className='mt-3 text-center'>
					<Link href='/login'>Back to Login</Link>
				</div>
			</Card.Body>
		</Card>
	);
};

ForgotPassword.layout = (page: ReactNode) => <GuestLayout>{page}</GuestLayout>;

export default ForgotPassword;
